// Registry of framework-specific workspaces. A module appears in the sidebar only when the org is
// ENROLLED in a framework whose NAME matches `match` (never by id: ids differ per org/env).
// Adding a module here is all a subscription-aware dashboard needs to surface a new workspace.
export const FRAMEWORK_MODULES = [
  {
    key: 'isms',
    match: /27001/i,
    section: {
      label: 'ISMS',
      items: [
        { to: '/dashboard/isms',       icon: 'fa-clipboard-list', label: 'ISMS Overview' },
        { to: '/dashboard/isms/roles', icon: 'fa-user-tie',       label: 'Roles & Owner' },
        { to: '/dashboard/isms/risks', icon: 'fa-exclamation-triangle', label: 'Risk Register' },
        { to: '/dashboard/isms/soa',   icon: 'fa-list-check',     label: 'Statement of Applicability' },
      ],
    },
  },
];

// Nav sections for the frameworks the org is enrolled in (names from /audit/compliance-summary).
export function modulesForFrameworks(frameworkNames = []) {
  return FRAMEWORK_MODULES
    .filter((m) => frameworkNames.some((n) => m.match.test(n || '')))
    .map((m) => m.section);
}
